class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add('is-yml-loading');
    this.ensureYmlSkeletons();
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  ymlLimit() {
    const attrLimit = Math.max(1, Number(this.getAttribute('data-fill-limit')) || 4);
    const isCartPage = !!this.closest('.myd-cart-page__host') || /\/cart\/?$/.test(window.location.pathname);
    return isCartPage ? Math.max(attrLimit, 6) : attrLimit;
  }

  createYmlSkeleton() {
    const el = document.createElement('div');
    el.className = 'myd-cart__yml-skel';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="myd-cart__yml-skel-media"></div>' +
      '<div class="myd-cart__yml-skel-body">' +
      '<span class="myd-cart__yml-skel-line myd-cart__yml-skel-line--type"></span>' +
      '<span class="myd-cart__yml-skel-line myd-cart__yml-skel-line--title"></span>' +
      '<span class="myd-cart__yml-skel-line myd-cart__yml-skel-line--price"></span>' +
      '<span class="myd-cart__yml-skel-line myd-cart__yml-skel-line--cta"></span>' +
      '</div>';
    return el;
  }

  ensureYmlSkeletons() {
    const scroller =
      this.querySelector('[data-myd-yml-scroller]') || this.querySelector('.myd-cart__yml-scroller');
    if (!scroller) return;

    const limit = this.ymlLimit();
    const realCount = scroller.querySelectorAll('.myd-cart__yml-card, .myd-search-card').length;
    let skelCount = scroller.querySelectorAll('.myd-cart__yml-skel').length;
    const needed = Math.max(0, limit - realCount - skelCount);
    for (let i = 0; i < needed; i += 1) {
      scroller.appendChild(this.createYmlSkeleton());
      skelCount += 1;
    }
  }

  clearYmlSkeletons() {
    this.querySelectorAll('.myd-cart__yml-skel').forEach((el) => el.remove());
    this.classList.remove('is-yml-loading');
  }

  async notifyLoaded() {
    this.dispatchEvent(
      new CustomEvent('myd:yml-recommendations', { bubbles: true, detail: { root: this } })
    );
    try {
      // Prefer the shared filler; event listeners may also call it — it de-dupes.
      if (typeof window.MYDCartFillYml === 'function') {
        await window.MYDCartFillYml(this);
      }
    } finally {
      this.clearYmlSkeletons();
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.classList.add('is-yml-loading');
    this.ensureYmlSkeletons();

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.classList.add('is-yml-loading');
        this.ensureYmlSkeletons();
        return this.notifyLoaded();
      })
      .catch((e) => {
        console.error(e);
        return this.notifyLoaded();
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
